// Module 0 (clôture) — bandeau sobre « Vous agissez sur : … » (population réelle de l'utilisateur).
import { Users, AlertTriangle } from 'lucide-react';

export default function BandeauPerimetre({ perimetre, style }) {
  if (!perimetre) return null;
  const vide = !perimetre.global && (perimetre.nb_personnes || 0) === 0;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderRadius: 8, fontSize: 12.5,
      background: vide ? '#FFF3E0' : '#F1F8E9', color: vide ? '#E65100' : '#33691E',
      border: `1px solid ${vide ? '#FFCC80' : '#DCEDC8'}`, ...style,
    }}>
      {vide ? <AlertTriangle size={14} /> : <Users size={14} />}
      <span>
        <b>Vous agissez sur :</b> {perimetre.libelle}
        {typeof perimetre.nb_personnes === 'number' && !vide ? ` — ${perimetre.nb_personnes} personne(s)` : ''}
      </span>
    </div>
  );
}
